import {GetContractualTermPendingParams} from 'domain/usecases/private/home/get-contractual-term-pending';
import {makeGetContractualTermPending} from 'main/factories/usecases/private/remote-home/get-contractual-term-pending-factory';

export const getContractualTermPending = (params: GetContractualTermPendingParams) =>
	makeGetContractualTermPending().get(params);
